import React from 'react';
import ControlledTextField from "./ControlledTextField";
import { SelectTextFieldNew } from "./SelectTextField";
import Grid from "@mui/material/Grid";
import { getAPIData } from '../utils/apiFunction';
import CropYearSelect from '../components/CropYearSelect';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import { Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import CallSplitIcon from '@mui/icons-material/CallSplit';

const OystersGroup = (props) => {
    const [stockItems, setStockItems] = React.useState(null);
    const [allStockItems, setAllStockItems] = React.useState(null);
    const [reduceItems, setReduceItems] = React.useState(null);
    //var oysters = props.oysters;
    React.useEffect(() => {
        var path = '/StockItems/GetUnprocessed';
        if (props.reduceItems || props.WIPcode) {
            path = '/StockItems/Get';
        } else if (props.processed) {
            if (props.processRunId) {
                path = '/Processing/GetProcessOutputs?ProcessRunId=' + props.processRunId;
            } else {
                path = '/StockItems/GetProcessed';
            }
        } else if (props.allStock) {
            path = '/StockItems/Get';
        } else {
            path = '/StockItems/GetUnprocessed';
        }
        getAPIData(path, sortStockItems(props.reduceItems || props.WIPcode ? setAllStockItems : setStockItems));
    }, [])
    const sortStockItems = (setFunc) => (list) => {
        setFunc(list.sort((a, b) => {
            console.log(a.myobid, b.myobid, a.myobid.localeCompare(b.myobid))
            if (a.grade?.sortOrder === b.grade?.sortOrder) {
                return -a.myobid.localeCompare(b.myobid);
            }
            return a.grade?.sortOrder - b.grade?.sortOrder;
        }));
    }


    React.useEffect(() => {
        if (props.reduceItems && props.supplier) {
            getAPIData('/Transfers/GetStockItems/' + props.supplier?.warehouseId, setReduceItems);
        }
    }, [props.supplier]);
    React.useEffect(() => {
        if (allStockItems) {
            if (reduceItems) {
                var newSI = [...allStockItems.filter((si) => {
                    return reduceItems.find((ri) => {
                        return ((ri.stockItemId === si.id) && (props.sameType === ri.toSame));
                    })
                })];
                setStockItems(newSI);
            } else if (props.WIPcode) {
                var newSI = [...allStockItems.filter((si) => {
                    return (si.myobid.length === 8) && (((si.myobid[4] + si.myobid[5]) === ('HS')) || ((si.myobid[4] + si.myobid[5]) === ('LO')));
                })];
                console.log(props.inputStockItemId)
                if (props.inputStockItemId) {
                    var inputSpeciesId = allStockItems.find((sIt) => (sIt.id === props.inputStockItemId))?.speciesId;
                    if (inputSpeciesId) {
                        newSI = newSI.filter((si) => {
                            return si.speciesId == inputSpeciesId;
                        });
                    }
                }
                setStockItems(newSI);
            }
        }
    }, [reduceItems, allStockItems]);

    const addLine = () => {
        var oysterListCPY = [...props.oysters];
        oysterListCPY.push({ tempId: uuidv4() });
        props.setOysters(oysterListCPY);
    }
    const removeLine = () => {
        var oysterListCPY = [...props.oysters];
        oysterListCPY.pop({});
        props.setOysters(oysterListCPY);
    }
    const setLine = (valToUpdate, ind) => {
        props.setOysters(oyLt => {
            var oysterListCPY = JSON.parse(JSON.stringify(oyLt));
            oysterListCPY[ind][valToUpdate.name] = valToUpdate.value;
            return oysterListCPY;
        });
    }
    const removeSpecficLine = (ind) => (e) => {
        props.setOysters(oyLt => {
            var oysterListCPY = JSON.parse(JSON.stringify(oyLt));
            oysterListCPY.splice(ind, 1);
            return oysterListCPY;
        });
    }
    console.log(props.oysters)
    // Build a map of mixedGroupId counts to decide highlighting
    const mixedGroupCounts = React.useMemo(() => {
        const counts = {};
        props.oysters?.forEach(o => {
            if (o?.mixedGroupId) {
                counts[o.mixedGroupId] = (counts[o.mixedGroupId] || 0) + 1;
            }
        });
        return counts;
    }, [props.oysters]);

    // Only force integer quantities if at least one mixed group has more than one line
    const requireInteger = React.useMemo(() => {
        return Object.values(mixedGroupCounts).some(c => c > 1);
    }, [mixedGroupCounts]);

    // Editable totals per mixed group (overrides computed sum when present)
    const [groupTotalsOverride, setGroupTotalsOverride] = React.useState({});

    // Persist original percent breakdown per mixed group so we can reuse it on reloads
    const originalPercentsRef = React.useRef({}); // { [mgid]: { byKey: { [lineKey]: pct } } }
    // Use a stable key that doesn't depend on lazy-loaded stockItem
    const makeLineKey = React.useCallback((o, idx) => (o?.id || o?.tempId || `${o?.mixedGroupId || 'mg'}_${idx}`), []);

    const roundInt = (v) => {
        const n = Number(v);
        if (isNaN(n)) return 0;
        return requireInteger ? Math.round(n) : n; // pass-through (allow decimals) when not required
    };

    const distributeAndRound = (rawQuantities, targetTotal) => {
        // rawQuantities: array of floats; targetTotal: integer
        const totalInt = roundInt(targetTotal);
        if (rawQuantities.length === 0) return [];
        // First get floors and remainders based on rounding
        const items = rawQuantities.map((q, idx) => ({ idx, raw: q, rounded: Math.round(q), remainder: q - Math.floor(q) }));
        let sumRounded = items.reduce((p, c) => p + c.rounded, 0);
        let diff = totalInt - sumRounded;
        if (diff === 0) {
            return items.sort((a,b)=>a.idx-b.idx).map(i => i.rounded);
        }
        // If sumRounded too low/high adjust by remainder priority
        const adjustOrder = items
            .map(it => ({ ...it, frac: it.raw - Math.floor(it.raw) }))
            .sort((a,b)=> diff>0 ? (b.frac - a.frac) : (a.frac - b.frac));
        let i = 0;
        while (diff !== 0 && i < adjustOrder.length) {
            if (diff>0) {
                adjustOrder[i].rounded += 1; diff--; i++;
            } else {
                if (adjustOrder[i].rounded > 0) { adjustOrder[i].rounded -= 1; diff++; }
                i++;
            }
        }
        // Map back to original order
        const finalMap = {};
        adjustOrder.forEach(it => { finalMap[it.idx] = it.rounded; });
        items.forEach(it => { if (finalMap[it.idx] === undefined) finalMap[it.idx] = it.rounded; });
        return rawQuantities.map((_, idx) => finalMap[idx]);
    };

    // Ensure we capture the initial percentage breakdown for a mixed group
    const ensureOriginalPercents = React.useCallback((mgid) => {
        if (!mgid || originalPercentsRef.current[mgid]) return;
        const list = props.oysters || [];
        const entries = [];
        list.forEach((o, idx) => { if (o?.mixedGroupId === mgid) entries.push({ o, idx }); });
        if (entries.length === 0) return;
        const total = entries.reduce((p, e) => p + (Number(e.o.quantity) || 0), 0);
        const basePercents = total > 0
            ? entries.map(e => ((Number(e.o.quantity) || 0) / total) * 100)
            : entries.map(() => 100 / entries.length);
        const byKey = {};
        entries.forEach((e, i) => { byKey[makeLineKey(e.o, e.idx)] = basePercents[i]; });
        originalPercentsRef.current[mgid] = { byKey };
    }, [props.oysters, makeLineKey]);

    // Build quantities from saved percents for a given total
    const quantitiesFromSavedPercents = React.useCallback((mgid, entries, total) => {
        const saved = originalPercentsRef.current[mgid]?.byKey || {};
        let pctArr = entries.map(({ o, idx }) => saved[makeLineKey(o, idx)]);
        const sumKnown = pctArr.reduce((p, c) => p + (typeof c === 'number' ? c : 0), 0);
        const missingIdxs = pctArr.map((p, i) => (typeof p === 'number' ? null : i)).filter(i => i !== null);
        if (missingIdxs.length > 0) {
            const remaining = Math.max(0, 100 - sumKnown);
            // Distribute remaining percent proportionally to current quantities of missing entries
            const sumMissingQty = missingIdxs.reduce((p, i) => p + (Number(entries[i].o.quantity) || 0), 0);
            if (sumMissingQty > 0) {
                missingIdxs.forEach(i => {
                    const q = Number(entries[i].o.quantity) || 0;
                    pctArr[i] = (q / sumMissingQty) * remaining;
                });
            } else {
                const share = remaining / missingIdxs.length;
                missingIdxs.forEach(i => { pctArr[i] = share; });
            }
        } else if (Math.abs(sumKnown - 100) > 0.0001) {
            pctArr = pctArr.map(p => (p / sumKnown) * 100);
        }
        const raw = pctArr.map(p => (total > 0 ? (p / 100) * total : 0));
        return distributeAndRound(raw, total);
    }, [distributeAndRound, makeLineKey]);

    // When lines are locked and only group total is editable, on reloads use saved breakdown
    React.useEffect(() => {
        if (!(props.lockGroupLines && props.disableGroupPercent)) return;
        const list = props.oysters || [];
        if (list.length === 0) return;
        // group by mixedGroupId
        const groups = {};
        list.forEach((o, idx) => {
            const mgid = o?.mixedGroupId;
            if (!mgid) return;
            (groups[mgid] ||= []).push({ o, idx });
        });
        let changed = false;
        const next = list.slice();
        Object.entries(groups).forEach(([mgid, entries]) => {
            ensureOriginalPercents(mgid);
            const total = entries.reduce((p, e) => p + (Number(e.o.quantity) || 0), 0);
            const desired = quantitiesFromSavedPercents(mgid, entries, total);
            entries.forEach((e, i) => {
                const newQ = Math.round(desired[i]);
                if (Math.round(Number(e.o.quantity) || 0) !== newQ) {
                    changed = true;
                    const updated = { ...next[e.idx], quantity: newQ };
                    if (updated.stockItem && updated.stockItem.bagCount) {
                        updated.bags = Math.floor(newQ / (updated.stockItem.bagCount));
                    }
                    next[e.idx] = updated;
                }
            });
        });
        if (changed) props.setOysters(next);
    }, [props.oysters, props.lockGroupLines, props.disableGroupPercent, ensureOriginalPercents, quantitiesFromSavedPercents]);

    const setEditableGroupTotal = (mgid, newTotal) => {
        const val = roundInt(newTotal);
        if (val < 0) return;
        // Find current sum for that group
        const groupEntriesFlat = (props.oysters || []).map((o, idx) => ({ o, idx })).filter(x => x.o.mixedGroupId === mgid);
        let updatedOysters;
        if (props.lockGroupLines && props.disableGroupPercent) {
            // Use saved percent breakdown to distribute
            ensureOriginalPercents(mgid);
            const rounded = quantitiesFromSavedPercents(mgid, groupEntriesFlat, val);
            updatedOysters = (props.oysters || []).map((o, idx) => {
                const entryIdx = groupEntriesFlat.findIndex(g => g.idx === idx);
                if (entryIdx === -1) return o;
                const newQuantity = rounded[entryIdx];
                const updated = { ...o, quantity: newQuantity };
                if (updated.stockItem && updated.stockItem.bagCount) {
                    updated.bags = Math.floor(newQuantity / (updated.stockItem.bagCount));
                }
                return updated;
            });
        } else {
            // Fallback: proportional scaling of current quantities
            const currentSum = groupEntriesFlat.reduce((p, c) => p + (roundInt(c.o.quantity) || 0), 0);
            if (currentSum === 0) {
                const base = groupEntriesFlat.length > 0 ? val / groupEntriesFlat.length : 0;
                const raw = groupEntriesFlat.map(() => base);
                const rounded = distributeAndRound(raw, val);
                updatedOysters = (props.oysters || []).map((o, idx) => {
                    const entryIdx = groupEntriesFlat.findIndex(g => g.idx === idx);
                    if (entryIdx === -1) return o;
                    return { ...o, quantity: rounded[entryIdx] };
                });
            } else {
                const scale = val / currentSum;
                const raw = groupEntriesFlat.map(g => (roundInt(g.o.quantity) || 0) * scale);
                const rounded = distributeAndRound(raw, val);
                updatedOysters = (props.oysters || []).map((o, idx) => {
                    const entryIdx = groupEntriesFlat.findIndex(g => g.idx === idx);
                    if (entryIdx === -1) return o;
                    return { ...o, quantity: rounded[entryIdx] };
                });
            }
        }
        setGroupTotalsOverride(prev => ({ ...prev, [mgid]: val }));
        props.setOysters(updatedOysters);
    };

    const updateGroupLinePercentage = (mgid, lineGlobalIndex, newPercentRaw) => {
    const list = props.oysters || [];
        const cleanPercent = Math.max(0, Math.min(100, Number(newPercentRaw)));
        // Determine effective group total (fixed unless user edited total field)
        let computedTotal = 0;
        const groupIndices = [];
        list.forEach((o, idx) => {
            if (o.mixedGroupId === mgid) {
                groupIndices.push(idx);
                computedTotal += Number(o.quantity) || 0;
            }
        });
        if (groupIndices.length === 0) return;
    const effectiveTotal = groupTotalsOverride[mgid] !== undefined ? groupTotalsOverride[mgid] : computedTotal;
        // Avoid division by zero; if total is 0 and user sets a percent, just distribute based on percent choices later
        const quantities = groupIndices.map(idx => Number(list[idx].quantity) || 0);
        const currentPercents = quantities.map(q => effectiveTotal > 0 ? (q / effectiveTotal) * 100 : (100 / groupIndices.length));
        // Compute remaining percent after new line's value
        const targetLocalIndex = groupIndices.indexOf(lineGlobalIndex);
        if (targetLocalIndex === -1) return;
        const remainingPercent = Math.max(0, 100 - cleanPercent);
        // Sum of other percents currently
        let otherCurrentSum = 0;
        currentPercents.forEach((p, i) => { if (i !== targetLocalIndex) otherCurrentSum += p; });
        const newPercents = [...currentPercents];
        newPercents[targetLocalIndex] = cleanPercent;
        if (groupIndices.length === 1) {
            newPercents[0] = 100; // single line must remain 100%
        } else if (otherCurrentSum === 0) {
            // Distribute remaining equally
            const eq = remainingPercent / (groupIndices.length - 1);
            newPercents.forEach((_, i) => { if (i !== targetLocalIndex) newPercents[i] = eq; });
        } else {
            const scale = remainingPercent / otherCurrentSum;
            newPercents.forEach((p, i) => {
                if (i !== targetLocalIndex) {
                    newPercents[i] = p * scale;
                }
            });
        }
        // Normalize rounding issues so sum exactly 100
        let sumP = newPercents.reduce((p, c) => p + c, 0);
        if (Math.abs(sumP - 100) > 0.0001) {
            // Adjust last non-target entry
            for (let i = newPercents.length - 1; i >= 0; i--) {
                if (i !== targetLocalIndex || newPercents.length === 1) {
                    newPercents[i] += (100 - sumP);
                    break;
                }
            }
        }
        // Compute new quantities based on effectiveTotal (fixed). If effectiveTotal = 0, keep zero quantities.
        // Compute raw float quantities then round preserving total
        const rawQuantities = newPercents.map(p => effectiveTotal > 0 ? (p / 100) * effectiveTotal : 0);
        const roundedQuantities = distributeAndRound(rawQuantities, effectiveTotal);
        const newList = list.map((o, idx) => {
            if (o.mixedGroupId !== mgid) return o;
            const localIndex = groupIndices.indexOf(idx);
            if (localIndex === -1) return o;
            const newQuantity = roundedQuantities[localIndex];
            let updated = { ...o, quantity: newQuantity };
            if (o.stockItem && o.stockItem.bagCount) {
                const newBags = Math.floor(newQuantity / (o.stockItem.bagCount));
                updated.bags = newBags;
            }
            return updated;
        });
        props.setOysters(newList);
    };

    const clearGroupTotalOverride = (mgid) => {
        setGroupTotalsOverride(prev => {
            if (prev[mgid] === undefined) return prev;
            const cp = { ...prev };
            delete cp[mgid];
            return cp;
        });
    };

    const splitBin = (ind) => () => {
        if (!props.allowSplit) return; // guard: split only when explicitly allowed
        props.setOysters(prev => {
            const list = JSON.parse(JSON.stringify(prev));
            const original = list[ind];
            // Ensure both lines share a mixedGroupId
            const mgid = original.mixedGroupId || uuidv4();
            original.mixedGroupId = mgid;
            // Clone entry
            const clone = { ...original, id: undefined, tempId: uuidv4() };
            // Reset quantitative fields for the new clone so user can edit
            // Assumption: bins/bags represent containers; we move 1 bin if possible, else leave zero for manual edit.
            if (clone.bins && clone.bins > 1) {
                clone.bins = 1;
                original.bins = (original.bins || 0) - 1;
                if (original.stockItem) {
                    // Recalculate quantities
                    const si = original.stockItem;
                    original.quantity = (original.bags ? original.bags : 0) * (si.bagCount || 0) + (original.bins ? original.bins : 0) * (si.binCount || 0);
                    clone.quantity = (clone.bags ? clone.bags : 0) * (si.bagCount || 0) + (clone.bins ? clone.bins : 0) * (si.binCount || 0);
                }
            } else {
                // Zero out numeric values for manual input
                clone.bins = 0;
                clone.bags = 0;
                clone.quantity = 0;
            }
            clone.mixedGroupId = mgid;
            list.splice(ind + 1, 0, clone);
            return list;
        });
    };
    return (<React.Fragment>
        {!props.noTitle ? <Grid item xs={12} >
            <h3 style={{ fontWeight: 450 }}>Oysters</h3>
        </Grid> : ''}
        {(() => {
            const elements = [];
            const list = props.oysters || [];

    const renderLine = (oL, ind, inGroup, groupTotal) => (
                <div key={(oL.id ? oL.id : oL.tempId) + '_row'} style={{ position: 'relative', marginBottom: inGroup ? '2px' : '4px' }}>
            <OysterLine
                disableStockItem={props.disableStockItem}
                showAsUnits={props.showAsUnits}
                noUnits={props.noUnits}
                data={oL}
                items={stockItems}
                setLine={setLine}
                index={ind}
                disabled={props.disabled}
                cropYear={props.cropYear}
                supplier={props.supplier}
                nameFunc={props.nameFunc}
                groupTotal={groupTotal}
                onPercentChange={(val) => updateGroupLinePercentage(oL.mixedGroupId, ind, val)}
                onManualQuantityChange={() => oL.mixedGroupId && clearGroupTotalOverride(oL.mixedGroupId)}
                disableGroupPercent={props.disableGroupPercent}
                lockGroupLines={props.lockGroupLines}
        requireInteger={requireInteger}
            />
                    <div style={{ position: 'absolute', right: '0px', top: '4px', display: 'flex', gap: '4px' }}>
                        {props.allowSplit ? (
                            <React.Fragment>
                            <IconButton aria-label="split-bin" size="small" onClick={splitBin(ind)} disabled={props.disabled || props.disableSplitRemove} title="Split Bin">
                                <CallSplitIcon fontSize="inherit" />
                            </IconButton>
                        <IconButton aria-label="remove" size="small" onClick={removeSpecficLine(ind)} disabled={props.disabled || props.disableSplitRemove} title="Remove Line" >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                        </React.Fragment>
                        ) : null}
                    </div>
                </div>
            );

            for (let i = 0; i < list.length; i++) {
                const current = list[i];
                const mgid = current?.mixedGroupId;
                const qualifies = mgid && mixedGroupCounts[mgid] > 1;
                const prevSame = i > 0 && list[i - 1]?.mixedGroupId === mgid;
                if (qualifies && !prevSame) {
                    // determine group extent and total first
                    let j = i;
                    let computedTotal = 0;
                    while (j < list.length && list[j]?.mixedGroupId === mgid) {
                        computedTotal += Number(list[j].quantity ? list[j].quantity : 0);
                        j++;
                    }
                    const effectiveTotal = groupTotalsOverride[mgid] !== undefined ? groupTotalsOverride[mgid] : computedTotal;
                    const groupChildren = [];
                    for (let k = i; k < j; k++) {
                        groupChildren.push(renderLine(list[k], k, true, effectiveTotal));
                    }
                    elements.push(
                        <div key={'grp_' + mgid + '_' + i} style={{ border: '2px solid #000', borderRadius: '6px', padding: '14px 18px', marginBottom: '14px' }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>Bin Breakdown</Typography>
                            {groupChildren}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                                <span style={{ fontWeight: 600 }}>Group Total:</span>
                                <ControlledTextField
                                    title=""
                                    state={effectiveTotal}
                                    setState={(val) => setEditableGroupTotal(mgid, val)}
                                    disabled={props.disabled}
                                    number
                                    width={'120px'}
                                />
                            </div>
                        </div>
                    );
                    i = j - 1; // advance loop to end of group
                } else if (!qualifies) {
                    elements.push(renderLine(current, i, false, null));
                } else {
                    // continuation row handled in group block
                }
            }
            return elements;
        })()}
        {!props.single ? <React.Fragment><Stack direction="row" spacing={1}>
            <IconButton aria-label="add" onClick={addLine} disabled={props.disabled}>
                <AddIcon />
            </IconButton>
            <IconButton aria-label="remove" onClick={removeLine} disabled={props.disabled}>
                <RemoveIcon />
            </IconButton>
        </Stack>
            <ControlledTextField title="Total Quantity (doz)" state={totalQuantity(props.oysters)} disabled number />
        </React.Fragment> : ''}

    </React.Fragment>)
}
const totalQuantity = (list) => {
    return list?.reduce((p, c) => { return p + (c.quantity ? Number(c.quantity) : 0) }, 0)
}
const OysterLine = (props) => {
    var ol = props.data;
    const groupTotal = props.groupTotal; // may be null if not in a mixed group

    const remSS = (inp) => {
        if (inp.description.includes('Single Seed')) {
            return inp.description.replace('Single Seed', '');
        } else {
            return inp.description;
        }
    }
    const extractCode = val => {
        if (val) {
            updateFunction('cropYear')(val.code)
        }
    }
    const updateFunction = (name) => (val) => {
        var pv = !props.nonStock && ol.stockItem && props.priceList && (Number(ol.price) !== (props.priceList.find((pl) => { return pl.stockItemId === ol.stockItem.id })?.price))
        props.setLine({ name: 'priceVary', value: pv }, props.index);
    const isContainerField = ((name === 'stockItem') || (name === 'bins') || (name === 'bags'));
    if (isContainerField && (ol.stockItem)) {
            var SI = ol.stockItem;
            var bags = ol.bags;
            var bins = ol.bins;
            if (name === 'stockItem') {
                SI = val;
            }
            if (name === 'bags') {
                bags = val;
            }
            if (name === 'bins') {
                bins = val;
            }
            var quant = (bags ? bags : 0) * SI.bagCount + (bins ? bins : 0) * SI.binCount;
            if (props.requireInteger) {
                quant = Math.round(quant);
            }
            props.setLine({ name: 'quantity', value: quant }, props.index);
            if (ol.mixedGroupId && props.onManualQuantityChange) {
                props.onManualQuantityChange();
            }
        }
        if (name === 'quantity') {
            const numVal = Number(val) || 0;
            if (props.requireInteger) {
                val = Math.round(numVal);
            } else {
                // keep as decimal (limit to 2 decimal places to avoid excessive precision noise)
                val = Number(numVal.toFixed(2));
            }
            if (ol.mixedGroupId && props.onManualQuantityChange) {
                props.onManualQuantityChange();
            }
        }
        props.setLine({ name: name, value: val }, props.index);

    }
    if (!ol.stockItem && ol.stockItemId) {
        var newStockItem = props.items?.find((i) => { return i.id === ol.stockItemId });
        if (newStockItem) {
            updateFunction('stockItem')(newStockItem);
        }
    }
    // Derived percentage from current quantity (used to sync when not actively editing)
    const pct = groupTotal && groupTotal > 0 ? ((Number(ol.quantity || 0) / groupTotal) * 100) : null;
    const [percentInput, setPercentInput] = React.useState(pct != null ? pct.toFixed(2) : '');
    const [editingPercent, setEditingPercent] = React.useState(false);
    // Sync from quantity changes unless user is typing
    React.useEffect(() => {
        if (!editingPercent) {
            if (pct != null) setPercentInput(pct.toFixed(2)); else setPercentInput('');
        }
    }, [pct, editingPercent]);
    const handlePercentChange = (v) => {
        if (props.disableGroupPercent) return; // no adjustments allowed
        setEditingPercent(true);
        setPercentInput(v);
        if (props.onPercentChange) {
            const num = Number(v);
            if (!isNaN(num)) {
                props.onPercentChange(num);
            }
        }
    };
    const handlePercentBlur = (v) => {
        if (props.disableGroupPercent) return; // no adjustments allowed
        setEditingPercent(false);
        if (props.onPercentChange) {
            const num = Number(v);
            if (!isNaN(num)) props.onPercentChange(num);
        }
    };

    const isGrouped = !!ol.mixedGroupId;
    const lockThisLine = !!props.lockGroupLines && isGrouped;
    return <Grid key={props.key} container spacing={2} mb={1} style={{ borderBottom: '1px solid lightgrey' }}>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
            <SelectTextFieldNew key={'si' + props.key} title="Stock Item" state={ol.stockItem} nameFunc={props.nameFunc ? props.nameFunc : remSS} valueFunc={v => v?.id} list={props.items} setState={updateFunction('stockItem')} disabled={props.disableStockItem || props.disabled || lockThisLine} />
        </Grid>
        {!props.noUnits ? <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
            <ControlledTextField key={'bg' + props.key} title={props.showAsUnits ? 'Units' : "Bags"} state={ol.bags} setState={updateFunction('bags')} disabled={props.disabled || lockThisLine} number />
        </Grid> : null}
        {!props.showAsUnits && !props.noUnits ? <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
            <ControlledTextField key={'bi' + props.key} title="Bins" state={ol.bins} setState={updateFunction('bins')} disabled={props.disabled || lockThisLine} number />
        </Grid> : null}
        <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
            <ControlledTextField key={'qua' + props.key} title="Quantity (doz)" state={ol.quantity} setState={updateFunction('quantity')} disabled={props.disabled || lockThisLine} number />
        </Grid>
        {props.cropYear ? <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
            <CropYearSelect key={'cy' + props.key} supplier={props.supplier} estId={ol.cropYear} state={ol.cropYear} setState={extractCode} disabled={props.disabled} />
        </Grid> : ''}
        {props.showAsUnits && ol.stockItem && ol.quantity && ((ol.quantity / ol.stockItem?.bagCount) !== Number(ol.bags)) ? <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
            <Typography variant="h3" style={{ marginTop: '1rem' }}>{ol.stockItem.bagCount ? ("Calculated Units: " + (Number(ol.quantity) / (Number(ol.stockItem.bagCount))).toFixed(1)) : ''}</Typography>
        </Grid> : null}
    {groupTotal ? <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
            <ControlledTextField
                key={'pct' + props.key}
                title="% of Group"
                state={percentInput}
                setState={handlePercentChange}
                updateDataOnBlur={handlePercentBlur}
        disabled={props.disabled || props.disableGroupPercent || lockThisLine}
                number
            />
        </Grid> : null}

    </Grid>
}
export default OystersGroup;